import AdminContentLayout from '../../components/layout/AdminContentLayout'
import AdminLayout from '../../components/layout/AdminLayout'
import CurriculumLayout from '../../components/layout/CurriculumLayout'
import BoardCreateBox from '../../components/admin/BoardCreateBox'

const BoardCreate = () => {
  return (
    <AdminLayout>
      <AdminContentLayout>
        <CurriculumLayout title={'Inquiries'}>
          <BoardCreateBox />
        </CurriculumLayout>
      </AdminContentLayout>
    </AdminLayout>
  )
}

export default BoardCreate
